/**
 * AI Provider 設定 schema — REQ-20260419007。
 * DB 僅存一組（key='ai.provider'）；apiKey 以 AES-256-GCM 加密。
 */
import { z } from 'zod';

/** 使用者輸入。apiKey 留空代表「保留原值」 */
export const AiProviderSettingInputSchema = z.object({
  enabled: z.boolean().default(false),
  baseUrl: z.string().trim().url().or(z.literal('')).default(''),
  apiKey: z.string().max(500).default(''),
  model: z.string().trim().min(1).max(100).default('gpt-4o-mini'),
  temperature: z.coerce.number().min(0).max(2).default(0.2),
  maxTokens: z.coerce.number().int().min(64).max(16000).default(2048),
  dailyCostUsd: z.coerce.number().min(0).max(1000).default(5),
});
export type AiProviderSettingInput = z.infer<typeof AiProviderSettingInputSchema>;

export const AiProviderSettingViewSchema = z.object({
  enabled: z.boolean(),
  baseUrl: z.string(),
  hasApiKey: z.boolean(),
  model: z.string(),
  temperature: z.number(),
  maxTokens: z.number(),
  dailyCostUsd: z.number(),
  updatedAt: z.string().datetime().nullable(),
});
export type AiProviderSettingView = z.infer<typeof AiProviderSettingViewSchema>;

export const AiProviderTestResultSchema = z.object({
  ok: z.boolean(),
  message: z.string(),
  model: z.string().optional(),
  latencyMs: z.number().optional(),
  tokensIn: z.number().optional(),
  tokensOut: z.number().optional(),
});
export type AiProviderTestResult = z.infer<typeof AiProviderTestResultSchema>;
